import { useDispatch } from 'react-redux';

import { ComponentsDispatch } from '../store';

const useDispatchSetterStore = <T>(getSetterActions: (newState: Partial<T>) => any) => {
    const dispatch = useDispatch<ComponentsDispatch>();

    return (newState: Partial<T>) => dispatch(getSetterActions(newState));
};

export default useDispatchSetterStore;
